var _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDownloadPdf(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "download-cloud"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    d: "M8.73113 16.4574L12.0019 19.7282M12.0019 19.7282L15.2728 16.4574M12.0019 19.7282V12.3689M19.2631 17.3487C19.9741 16.8488 20.5072 16.1354 20.7851 15.312C21.0631 14.4885 21.0714 13.5979 20.8089 12.7694C20.5464 11.941 20.0268 11.2177 19.3254 10.7045C18.6239 10.1914 17.7772 9.91513 16.9082 9.91581H15.8779C15.6319 8.95736 15.1718 8.06718 14.532 7.31231C13.8923 6.55743 13.0896 5.95752 12.1845 5.55774C11.2793 5.15796 10.2953 4.96873 9.30641 5.00429C8.31755 5.03985 7.34963 5.29928 6.47554 5.76304C5.60145 6.22681 4.84395 6.88282 4.26008 7.6817C3.67621 8.48058 3.28118 9.40151 3.10473 10.3752C2.92828 11.3488 2.975 12.3498 3.24138 13.3028C3.50777 14.2557 3.98687 15.1358 4.64262 15.8769",
    stroke: "#344054",
    strokeWidth: 1.67,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadPdf);
export default __webpack_public_path__ + "static/media/downloadPdf.0f904b678137c11965bf35b20db76c09.svg";
export { ForwardRef as ReactComponent };